import { Component, OnDestroy, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { NavigationEnd, Router } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { ActivityPingService } from './shared/services/activity-ping.service';

@Component({
  standalone: false,
  selector: 'app-root',
  template: '<router-outlet />',
})
export class AppComponent implements OnInit, OnDestroy {
  private readonly subscription = new Subscription();
  private authenticatedUserId: string | null = null;

  constructor(
    private readonly angularFireAuth: AngularFireAuth,
    private readonly router: Router,
    private readonly activityPingService: ActivityPingService,
  ) {}

  ngOnInit() {
    this.subscription.add(
      this.angularFireAuth.authState.subscribe((user) => {
        if (!user) {
          this.authenticatedUserId = null;
          this.activityPingService.stop();
          return;
        }

        this.authenticatedUserId = user.uid;
        this.activityPingService.start(user.uid);
      }),
    );

    this.subscription.add(
      this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
        if (this.authenticatedUserId) {
          this.activityPingService.start(this.authenticatedUserId);
        }
      }),
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.activityPingService.stop();
  }
}
